module.exports = __webpack_public_path__ + "assets/img/Affiches_001.8635a235.jpg";